<template>
  <div class="testInfo">
    <template v-if="isFinish && !isHaveData">
      <div class="test_box">
        <van-divider :style="{ color: '#999', borderColor: '#ccc', fontSize: '0.28rem' }">输入订单号进行查询</van-divider>
        <div>
          <van-field v-model="fetch.order_sn" type="number" input-align="center" label="" placeholder="请输入订单号" size="large"/>
        </div>
        <div style="padding:0.3rem 0.5rem 0.3rem">
          <van-button :loading="loading" type="primary" block round loading-text="查询中..." @touchstart="fetchOrder">查询</van-button>
        </div>
        <div>
          <van-empty description="未找到相应结果，请输入订单号查询" />
        </div>
      </div>
    </template>
    <template v-if="isFinish && isHaveData">
      <!-- <div class="logo">
        <img src="../../../assets/img/logo.png" alt />
      </div> -->
      <div class="part part1">
        <div>
          <span>商户名称</span>
          <span class="ellipsis-1">{{list.mer_name}}</span>
        </div>
        <div>
          <span>摊位号</span>
          <span class="ellipsis-1">{{list.booth_name}}</span>
        </div>
        <div>
          <span>交易单号</span>
          <span class="ellipsis-1">{{list.order_sn}}</span>
        </div>
        <div>
          <span>交易时间</span>
          <span>{{list.pay_time | toTime}}</span>
        </div>
        <div>
          <span>上游信息</span>
          <span>{{list.company_name || '暂无'}}</span>
        </div>
        <div></div>
      </div>
      <template>
        <div class="part part1" v-for="(item,index) in prolist" :key="index">
          <div>
            <span>商品名称</span>
            <span class="ellipsis-1">{{item.p_name}}</span>
          </div>
          <!-- <div>
            <span>供应商</span>
            <span class="ellipsis-1">{{item.good.supplier_name || '暂无'}}</span>
          </div> -->
          <!-- <div>
            <span>产地证明</span>
            <div>
              <van-uploader disabled :fileList="item.imgs" :show-upload="false" :deletable="false"/>
            </div>
          </div> -->
          <div>
            <span>商品单价</span>
            <span class="ellipsis-1">{{item.price}}元/kg</span>
          </div>
          <div>
            <span>商品重量</span>
            <span class="ellipsis-1">{{item.tare_weight}}kg</span>
          </div>
          <div>
            <span>商品小计</span>
            <span class="ellipsis-1">{{(item.total_price)}}元</span>
          </div>
          <div class="check" v-if="item.checkinfo && item.checkinfo.length>0" >
            <span @click="goCheckInfo(item.checkinfo)">检测信息</span>
            <span @click="goGoodsBack(item.special_id,item.base_type)">商品追溯</span>
          </div>
          <div v-else></div>
        </div>
        <div class="part part1">
          <div>
            <span>合计金额</span>
            <span>{{list.total_amount}}元</span>
          </div>
          <div></div>
        </div>
      </template>
      <div class="part part2">
        <div class="title">商户点评</div>
        <div class="star">
          <!-- <span>好评：</span> -->
          <van-rate
            v-model="subData.stat_number"
            void-icon="star"
            void-color="#eee"
            :size="32"
            :gutter="18"
          />
        </div>
        <div class="eval">
          <span
            :class="{'checked':subData.is_high_attitude==1}"
            @click="subData.is_high_attitude==0?subData.is_high_attitude=1:subData.is_high_attitude=0"
          >态度好</span>
          <span
            :class="{'checked':subData.is_high_quality==1}"
            @click="subData.is_high_quality==0?subData.is_high_quality=1:subData.is_high_quality=0"
          >品质好</span>
          <span
            :class="{'checked':subData.is_fresh==1}"
            @click="subData.is_fresh==0?subData.is_fresh=1:subData.is_fresh=0"
          >新鲜</span>
          <span
            :class="{'checked':subData.is_cheap==1}"
            @click="subData.is_cheap==0?subData.is_cheap=1:subData.is_cheap=0"
          >划算</span>
        </div>
        <div class="star"></div>
        <div class="eval">
          <span
            :class="{'checked-low':subData.is_high_attitude==0}"
            @click="subData.is_high_attitude==0?subData.is_high_attitude=1:subData.is_high_attitude=0"
          >态度差</span>
          <span
            :class="{'checked-low':subData.is_high_quality==0}"
            @click="subData.is_high_quality==0?subData.is_high_quality=1:subData.is_high_quality=0"
          >品质差</span>
          <span
            :class="{'checked-low':subData.is_fresh==0}"
            @click="subData.is_fresh==0?subData.is_fresh=1:subData.is_fresh=0"
          >不新鲜</span>
          <span
            :class="{'checked-low':subData.is_cheap==0}"
            @click="subData.is_cheap==0?subData.is_cheap=1:subData.is_cheap=0"
          >不划算</span>
        </div>
        <div class="btn" @click="sub()">提 交</div>
      </div>
    </template>
  </div>
</template>

<script>
import { timestampToTime } from "@/utils/timestamp";
import { getTicketInfo, subEval } from "@/api/ticket";
export default {
  name: "testInfo",
  data() {
    return {
      loading:false,
      isFinish:false,
      isHaveData:false,
      list: {},
      prolist: [],

      fetch:{
        order_sn:'',
      },

      subData: {
        order_sn: "",
        third_order_sn:'',
        stat_number: 5,
        is_high_attitude: 1,
        is_high_quality: 1,
        is_cheap: 1,
        is_fresh: 1,
      }
    };
  },
  filters: {
    toTime: function(s) {
      return timestampToTime(s);
    }
  },
  created() {
    this.fetch.order_sn = this.$route.query.order_sn || '';
    this.fetchOrder()
  },
  mounted() {},
  methods: {
    // 查询订单是否存在
    fetchOrder(){
      this.loading = true
      getTicketInfo(this.fetch).then(res => {
        if (res.resultCode == 1) {
          this.isFinish = true
          this.isHaveData = true
          this.loading = false
          // this.$toast.clear()
          this.list = res.resultInfo;
          var pro_list = res.resultInfo.pro_list || []
          this.prolist = [];
          for (let i = 0; i < pro_list.length; i++) {
            const item = pro_list[i];
            item.imgs = []
            // if(item.good.region_img){
            //   for (let j = 0; j < item.good.region_img.split(',').length; j++) {
            //     const i_j = item.good.region_img.split(',')[j];
            //     item.imgs.push({
            //       url:i_j,
            //       name:'1'
            //     })
            //   }
            // }
            this.prolist.push(item)
          }
          
        console.log(12121)
        }
      }).catch(err=>{
        console.log(err)
        this.isFinish = true
        this.isHaveData = false
        this.loading = false
      })
    },
    /**
     * 检测信息
     */
    // goCheckInfo(checkInfo){
    //   let info = JSON.stringify(checkInfo)
    //   this.$router.push({
    //     path:'/testInfo',
    //     query:{
    //       info,
    //     }
    //   })
    // },
    /**
     * 商品追溯
     */
    goGoodsBack(special_id,base_type){
      if(special_id>0){
        this.$router.push(`/goodsBack?special_id=${special_id}&type=${base_type}`)
      }else{
        this.$toast("暂无追溯信息")
      }
    },
    /**
     * 提交评分
     */
    sub() {
      // this.subData.order_sn = this.fetch.order_sn
      // subEval(this.subData).then(res => {
      //   if (res.resultCode == 1) {
          this.$toast("评价成功");
          this.subData = {
            order_sn: "",
            stat_number: 5,
            is_high_attitude: 1,
            is_high_quality: 1,
            is_cheap: 1,
            is_fresh: 1
          };
      //   }
      // });
    }
  }
};
</script>

<style lang="less" scoped>
.testInfo {
  background-color: #f5f5f5;
  min-height: calc(100% - 0.2rem );
  overflow: hidden;
  padding-bottom: 0.2rem;
  .test_box{
    position: fixed;
    z-index: 88;
    top: 0.88rem;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fafafa;
  }
  .logo {
    margin: 0.3rem auto 0.1rem;
    text-align: center;
    padding: 0.3rem 0;
    img {
      width: 5rem;
      // height: 1.33rem;
    }
  }
  .part {
    width: 6.5rem;
    margin: 0.3rem auto 0;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.2rem;
    font-size: 0.24rem;
    .check {
      display: flex;
      justify-content: space-around;
      font-size: 0.3rem;
      padding-top: 0.3rem;
      border-top: 0.01rem solid #f5f5f5;
      > span {
        width: 1.7rem;
        text-align: center;
        line-height: 0.5rem;
        letter-spacing: 0.05rem;
        color: #fff;
        background-color: #33d179;
        border-radius: 0.04rem;
      }
    }
  }
  .part1 {
    > div:not(:last-of-type) {
      line-height: 0.61rem;
      display: flex;
      justify-content: space-between;
      font-size: 0.32rem;
      > span:first-child {
        color: #333;
        min-width: 1.28rem;
      }
      > span:last-child {
        color: #666;
        flex-grow: 1;
        text-align: right;
      }
    }
  }
  .part2 {
    .title {
      font-size: 0.32rem;
      color: #333;
      margin-top: 0.1rem;
    }
    .star {
      text-align: center;
      margin-top: 0.48rem;
      margin-bottom: 0.6rem;
      // font-size: 0.3rem;
      >span{
        display: inline-block;
        line-height: 0.7rem;
        vertical-align: top;
      }
    }
    .eval {
      display: flex;
      justify-content: space-around;
      > span {
        width: 1.2rem;
        line-height: 0.4rem;
        color: #999;
        font-size: 0.26rem;
        border: 0.01rem solid #cccccc;
        text-align: center;
      }
      .checked {
        color: #33d179;
        border-color: #33d179;
      }
      .checked-low {
        color: #FD6D73;
        border-color: #FD6D73;
      }
    }
    .btn {
      width: 6.1rem;
      line-height: 0.8rem;
      color: #fff;
      background-color: #00c657;
      border-radius: 0.44rem;
      text-align: center;
      font-size: 0.42rem;
      margin: 0.9rem auto 0.53rem;
      box-shadow: 0px 2px 43px 0px rgba(51, 209, 121, 0.4);
    }
  }
}
</style>